import { render, staticRenderFns } from "./Car.vue?vue&type=template&id=1166aa9e&scoped=true"
import script from "./Car.vue?vue&type=script&lang=js"
export * from "./Car.vue?vue&type=script&lang=js"
import style0 from "./Car.vue?vue&type=style&index=0&id=1166aa9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1166aa9e",
  null
  
)

export default component.exports